export type ChannelSettingsFormData = {
    title: string;
    description: string;
    timer: number;
    hideResults: boolean;
    qrColor: string;
    votersVp: string;
    ctaMsg: string;
    isEmailRequired: boolean;
    collectProfession: boolean;
    collectSector: boolean;
    collectIndustry: boolean;
    collectRole: boolean;
    collectOrganizationType: boolean;
    collectCountry: boolean;
    collectNationality: boolean;
    collectAge: boolean;
    collectGender: boolean;
    allowDoubleVote: boolean;
    allowComments: boolean;
    displayProfilePicture: boolean;
    doubleVoteCooldownMinutes: number;
    customVariables: Array<{
        label: string;
        options: string;
    }>;
    isDemographic: boolean;
    useChannelProfileAsQrLogo: boolean;
    customTextFieldEnabled: boolean;
    customTextFieldQuestion: string;
    completionRedirectEnabled: boolean;
    completionRedirectUrl: string;
};

export const MAX_TITLE_LENGTH = 30;
export const MAX_CUSTOM_VARIABLES = 2;
export const MAX_CUSTOM_LABEL_LENGTH = 50;
export const MAX_VOTERS_VP_LENGTH = 200;
export const MAX_CTA_MSG_LENGTH = 120;
export const MAX_CUSTOM_TEXT_QUESTION_LENGTH = 100;
export const MAX_COMPLETION_REDIRECT_URL_LENGTH = 2048;
